import { render, staticRenderFns } from "./SSAlert.vue?vue&type=template&id=7ce99462&scoped=true"
import script from "./SSAlert.vue?vue&type=script&lang=js"
export * from "./SSAlert.vue?vue&type=script&lang=js"
import style0 from "./SSAlert.vue?vue&type=style&index=0&id=7ce99462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce99462",
  null
  
)

export default component.exports